import {Cookies} from "react-cookie";

const cookies = new Cookies();

export const setCookie = (name, value, options = { path: '/' }) => { // 쿠키에 정보 저장
    return cookies.set(name, value, options);
}

export const getCookie = (name) => { // 쿠키 저장된 정보 가져옴
    return cookies.get(name);
}

export const removeCookie = (name, options = { path: '/' }) => { // 쿠키에 저장된 정보 삭제
    return cookies.remove(name, options);
}
